import { useEffect, useState } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

export default function AnomalyPage() {
  const [wallets, setWallets] = useState({});

  useEffect(() => {
    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const p = msg.payload || {};
        const wallet = p.from || p.to;
        if (!wallet) return;

        setWallets((prev) => {
          const old = prev[wallet] || {
            total: 0,
            lastMinute: 0,
            lastTimestamp: Date.now(),

            swap: 0,
            contract: 0,
            bot: 0,
            gas: 0,
            complex: 0,

            pattern: 0, // повторяемость
          };

          // 🔥 проверка burst активности
          const now = Date.now();
          const delta = now - old.lastTimestamp;

          let burst = old.lastMinute;
          if (delta < 2000) {
            burst += 1;
          } else {
            burst = 1;
          }

          // 🔥 повторяемость (одинаковые события)
          let pattern = old.pattern;
          if (msg.event === "CONTRACT_CALL" || msg.event === "BOT_LIKE_TX") {
            pattern += 1;
          }

          const updated = {
            ...old,
            total: old.total + 1,
            lastMinute: burst,
            lastTimestamp: now,

            swap:
              old.swap +
              (msg.event === "REAL_SWAP" || msg.event === "SWAP_TOKENS" ? 1 : 0),

            contract:
              old.contract + (msg.event === "CONTRACT_CALL" ? 1 : 0),

            bot:
              old.bot + (msg.event === "BOT_LIKE_TX" ? 1 : 0),

            gas:
              old.gas + (msg.event === "GAS_SPIKE" ? 1 : 0),

            complex:
              old.complex + (msg.event === "COMPLEX_TX" ? 1 : 0),

            pattern,
          };

          return {
            ...prev,
            [wallet]: updated,
          };
        });
      } catch {}
    };

    return () => ws.close();
  }, []);

  // 🔥 anomaly scoring
  const ranked = Object.entries(wallets)
    .map(([addr, w]) => {
      const anomaly =
        w.lastMinute * 100 +       // burst активность
        w.bot * 80 +              // бот-поведение
        w.pattern * 60 +          // повторяемость
        w.gas * 40 +              // gas abuse
        w.complex * 50;           // сложные tx

      return { addr, ...w, anomaly };
    })
    .sort((a, b) => b.anomaly - a.anomaly)
    .slice(0, 30);

  const getType = (w) => {
    if (w.lastMinute > 10) return "🚀 Burst Activity";
    if (w.bot > 20) return "🤖 Bot Pattern";
    if (w.pattern > 20) return "🔁 Repetitive Behavior";
    if (w.gas > 10) return "⚠️ Gas Manipulation";
    if (w.complex > 10) return "🧩 Complex Strategy";
    return "• Normal";
  };

  const getInsight = (w) => {
    if (w.lastMinute > 10) return "Sudden spike in activity";
    if (w.bot > 20) return "Automated execution pattern";
    if (w.pattern > 20) return "Repeated identical actions";
    if (w.gas > 10) return "Abnormal gas usage";
    if (w.complex > 10) return "Advanced multi-step behavior";
    return "No anomaly detected";
  };

  return (
    <div style={{ minHeight: "100vh", background: "#000", color: "#fff" }}>
      <Header />

      <div style={{ padding: 24 }}>
        <h1 style={{ fontSize: 32, marginBottom: 10 }}>
          🚨 Anomaly Detection
        </h1>

        <p style={{ color: "#aaa", marginBottom: 20 }}>
          Detect unusual wallet behavior in real-time
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {ranked.map((w, i) => (
            <div
              key={w.addr}
              style={{
                padding: 16,
                border: "1px solid #222",
                borderRadius: 10,
                background: "#111",
              }}
            >
              <div style={{ fontSize: 12, color: "#777" }}>
                {w.addr}
              </div>

              <div style={{ fontSize: 20, margin: "6px 0" }}>
                #{i + 1} {getType(w)}
              </div>

              <div style={{ color: "#ff6b6b" }}>
                Anomaly Score: {w.anomaly}
              </div>

              <div style={{ fontSize: 13 }}>
                Burst: {w.lastMinute}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Bot: {w.bot} | Pattern: {w.pattern}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Gas: {w.gas} | Complex: {w.complex}
              </div>

              <div style={{ marginTop: 8, color: "#9cff9c", fontSize: 13 }}>
                Insight: {getInsight(w)}
              </div>

              <div style={{ fontSize: 12, color: "#555", marginTop: 6 }}>
                last seen: {Math.floor((Date.now() - w.lastTimestamp) / 1000)}s ago
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}